"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pagnacco": {
    "8fbcbbae": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "skipSearch": false
    }],
    "griis": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d47f183d": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "skipSearch": false
    }],
    "liola": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "81cf30fe": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "skipSearch": false
    }],
    "marolins": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b1cf35b": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "skipSearch": false
    }],
    "pazzan": [{
      "hkey": "5e8f1900",
      "slug": "pagnacco",
      "name": "Pagnacco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;